@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Task Exception"
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="!selectedOption
                    || (selectedOption.action === TaskProcessingActions.ReassignTask && !selectedOption.assignedUserId)">
    <div class="ws-flex-container-vertical ws-stretch">
        @if (options.length) {
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label>Action:</label>
                @for (option of options; track option) {
                    <div class="ws-flex-container-vertical">
                        <div class="ws-flex-auto ws-vertical-align-middle">
                            <label [for]="'option' + option.action + option.taskId" class="ws-font-weight-normal" helpTooltip [tooltipText]="option.title" position="bottom">
                                <input [id]="'option' + option.action + option.taskId" type="radio" name="exceptionOptions" [value]="option" [(ngModel)]="selectedOption" (ngModelChange)="selectedOptionChanged($event)" [disabled]="!option.isAuthorized"/>
                                {{ option.title }}
                            </label>
                        </div>
                        @if (selectedOption === option && selectedOption?.action === TaskProcessingActions.ReassignTask) {
                            <div class="ws-flex-auto" style="padding-bottom: 10px;">
                                <user-team-picker
                                    [userId]="option.assignedUserId"
                                    [teamId]="option.assignedTeamId"
                                    (userChange)="userChanged($event, option)"
                                    [required]="true">
                                </user-team-picker>
                            </div>
                        }
                    </div>
                }
                @if (!params.workflowStatus.canRescindTask && params.workflowStatus.noRescindReason) {
                    <div>
                        <label class="ws-font-weight-normal" style="color: var(--ace-danger)" position="bottom">
                            {{ params.workflowStatus.noRescindReason }}
                        </label>
                    </div>
                }
                <label>Comment:</label>
                <textarea ref-textarea [(ngModel)]="comment" rows="4"></textarea>
            </div>
        }

        @if (!options.length) {
            <div class="ws-flex-container-vertical ws-flex-auto">
                No options available
            </div>
        }
    </div>
</ws-modal-wrapper>
